import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { PLANS } from "@/constants";
import { memo } from "react";

export const PlansSection = memo(function PlansSection() {
  return (
    <section id="planos" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Escolha seu <span className="text-gradient">plano</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Teste grátis com 3 imagens. Assine para gerar mais.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {PLANS.filter((plan) => plan.id !== 'free').map((plan) => (
            <div 
              key={plan.id}
              className={`relative bg-card rounded-2xl border p-6 transition-all duration-300 hover:shadow-glow ${
                plan.popular 
                  ? 'border-primary shadow-elegant scale-105' 
                  : 'border-border hover:border-primary/50'
              }`}
            >
              {/* Popular badge */}
              {plan.popular && (
                <Badge className="absolute -top-3 left-1/2 -translate-x-1/2 gradient-primary border-0 px-4 py-1">
                  Popular
                </Badge>
              )}

              {/* Best value badge */}
              {plan.badge && (
                <Badge variant="secondary" className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-primary border-primary/20 px-4 py-1">
                  {plan.badge}
                </Badge>
              )}

              <div className="text-center pb-2 pt-2">
                <h3 className="text-xl font-bold mb-2">{plan.name}</h3>
                <div className="flex items-baseline justify-center gap-1">
                  <span className="text-3xl font-bold">R$ {plan.price.toFixed(2).replace('.', ',')}</span>
                  <span className="text-muted-foreground">/{plan.period}</span>
                </div>
                <p className="text-sm text-muted-foreground mt-2">
                  {plan.credits.toLocaleString('pt-BR')} imagens/mês
                </p>
              </div>

              <div className="space-y-6">
                <ul className="space-y-3">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" />
                      <span className="text-sm text-muted-foreground">
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>

                <Button 
                  className={`w-full ${plan.popular ? 'gradient-primary border-0' : ''}`}
                  variant={plan.popular ? 'default' : 'outline'}
                  asChild
                >
                  <Link to="/auth?tab=signup">
                    Começar Agora
                  </Link>
                </Button>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-muted-foreground mt-8">
          Teste grátis com 3 imagens para conhecer a plataforma. Assine para continuar gerando.
        </p>
      </div>
    </section>
  );
});
